import RVHero from 'assets/images/psp/hero/rv-hero.webp';

import vehicle10x25 from 'assets/images/icons/size-guide/vehicle-10x25.svg';
import vehicle10x30 from 'assets/images/icons/size-guide/vehicle-10x30.svg';
import vehicle10x40 from 'assets/images/icons/size-guide/vehicle-10x40.svg';
import vehicle10x50 from 'assets/images/icons/size-guide/vehicle-10x50.svg';
import vehicle10x35 from 'assets/images/icons/size-guide/vehicle-10x35.svg';
import RV1 from 'assets/images/psp/FeaturedImages/rv1.webp';
import RV2 from 'assets/images/psp/FeaturedImages/rv2.webp';
import RV3 from 'assets/images/psp/FeaturedImages/rv3.webp';
import RV4 from 'assets/images/psp/FeaturedImages/rv4.webp';
import truckBoatCarContentSectionSVG from 'assets/images/content-section/Illustration-Truck-Boat-Car.svg';

const videoDescription = [
	'RV storage comes in three main types, each with different protection levels and pricing: \n\n ' +
		'- **Indoor RV Storage:** Imagine an oversized garage with roll-up door access. The most expensive option, indoor storage for a motorhome, offers maximum weather protection and security, perfect for long-term storage and high-value RVs.\n\n' +
		'- **Indoor RV Storage Cost:** Looking into the cost of indoor RV storage near you? The highest tier of RV storage will cost you anywhere from $100–$500/month based on the length of your storage lease, and additional amenities like private parking and enhanced security.\n\n' +
		'- **Covered RV Storage:** A great mid-budget option that provides carport-style protection with roof coverage. Available as simple canopies or three-sided structures with partial walls. Perfect for RV users taking their recreational vehicles on and off the road more often, with ample weather protection.\n\n' +
		'- **Outdoor RV Storage:** Looking to safely store an RV on a budget? Look no further. Basic paved parking spaces are large enough for most campers, trailers, and RVs. Best for short-term storage that doesn’t break the bank.\n\n' +
		'- **Cost of Outdoor RV Storage:** Outdoor RV storage prices sit at a wide range, based on whether you want your RV storage space to be covered or uncovered. Covered RV storage costs average $125–$250 per month, while outdoor, uncovered storage will cost you $74–$150 per month.\n\n' +
		'Your choice depends on your budget, how often you use your RV, and how much protection your investment needs.',
];

const reviews = [
	{
		reviewTitle: 'Very Easy Process',
		reviewRating: 5,
		reviewText:
			'We needed to store our RV for a month after driving it out to San Diego from Missouri, and SpareFoot found us a storage facility to store the RV while we were gone to Hawaii for 3 weeks. It was so much more affordable than trying to convince parking lots near the airport to let us park our RV there.',
		reviewerInitials: 'DY',
		link: 'https://www.trustpilot.com/users/67ad13fc5aa6b3316f887bc7',
		reviewerName: 'David W. Young',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Finding a Parking Spot for Our RV Was Easy',
		reviewRating: 5,
		reviewText:
			'I was glad someone recommended this site to see what storage spaces were available for our 43’ RV. The site was very easy to use, and even though I got an email confirmation from SpareFoot, I called the storage company that I booked the spot with, and they confirmed it. I liked that I didn’t have to put in a credit card to reserve the spot.',
		reviewerInitials: 'MT',
		link: 'https://www.trustpilot.com/users/675496d616939d498599b1ac',
		reviewerName: 'Mamaw T',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Easy to use',
		reviewRating: 5,
		reviewText:
			'The site is easy to use, and I was able to find a storage location close to home. The location allowed us to view the space before committing to a lease. Our space is perfectly level. SpareFoot is an easy way to select an RV storage spot.',
		reviewerInitials: 'HW',
		link: 'https://www.trustpilot.com/reviews/66dc6f648a1a579e3866c223',
		reviewerName: 'Harry Wind',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle:
			'Very helpful and informative service for locating RV storage facilities',
		reviewRating: 5,
		reviewText:
			'Very helpful and informative service to provide information and assist with booking for RV storage. Saves a lot of time you might spend searching out the best sites and deals on your own.',
		reviewerInitials: 'DM',
		link: 'https://www.trustpilot.com/reviews/65186fffd2c531e38f5fa40b',
		reviewerName: 'Doug Mains',
		reviewDate: 'January 3rd, 2023',
	},
];

const faqs = [
	{
		question: 'What size storage do I need for an RV?',
		answer:
			"Choosing the right storage unit size for your RV depends primarily on your RV's class and dimensions. Here's what you need to know:\n\n" +
			'- **Class A Motorhomes** (the largest RVs) typically require storage units that are at least 12–14 feet wide and 35–45 feet deep. These luxury coaches can reach lengths of 35–45 feet and need the most spacious storage accommodations.\n\n' +
			'- **Class B Motorhomes** (van-style RVs) are the most compact option, usually fitting comfortably in 10x20 to 10x25 storage units. Their smaller footprint makes them the most storage-friendly option.\n\n' +
			'- **Class C Motorhomes** fall between Class A and B in size, typically requiring 10x30 to 12x35 storage units to accommodate their 20–35 foot length.\n\n' +
			'- **Travel Trailers** vary significantly in size, with lengths averaging around 20 feet and widths of 8 feet. Most travel trailers fit well in 10x25 to 10x35 storage units, depending on their specific dimensions.\n\n' +
			"When selecting your storage unit size, always measure your RV's total length, width, and height, including any exterior accessories like awnings, bike racks, or roof equipment. Add at least 2–3 feet of clearance on all sides for easy maneuvering and access to your RV's exterior.\n\n" +
			'**Pro RV Storage Tip from SpareFoot:** If your RV is on the borderline between two storage unit sizes, always choose the larger option. The extra space makes accessing your RV much easier and provides room for additional camping gear storage.\n\n' +
			"Most storage facilities offer units ranging from 10x15 feet up to 14x45 feet specifically for RV storage, ensuring you'll find the perfect fit for your recreational vehicle.",
	},
	{
		question: 'What information do I need to reserve an RV storage unit?',
		answer:
			'Many RV storage facilities require that you bring the following documents with you when you bring your car to move into the unit:\n\n' +
			'- Proof of auto registration\n' +
			'- Proof of car insurance\n' +
			'- Vehicle title\n' +
			'- The car must be drivable',
	},
	{
		question: 'Can I work on an RV in a storage unit?',
		answer:
			"Whether or not you can work on your RV in a storage unit depends on the facility's policies and the type of work you intend to do on your RV. Some storage units may prohibit any kind of vehicle maintenance or repairs on their premises due to liability concerns, fire hazards, or zoning regulations.\n\n" +
			'If the storage unit allows vehicle maintenance and repairs, you should still be aware of any restrictions they may have. For example, they may limit the types of repairs you can perform or require you to use certain equipment or tools to minimize the risk of damage to the unit or other vehicles nearby. Not abiding by facility policies could result in you being asked to leave the facility or potentially even incurring fines or legal penalties.',
	},
	{
		question: 'How often should I start my RV in storage?',
		answer:
			'If you plan to store your RV for an extended period, it is generally recommended to start your RV at least once a month to keep the battery charged and the engine lubricated.\n\n' +
			'When you start your RV, let it run for at least 30 minutes to circulate the oil and lubricate the engine. This helps prevent corrosion and rust in the engine components. It also helps keep the battery charged, which can drain over time if the RV is not in use.\n\n' +
			"However, if you plan to store your RV for less than a month, it may not be necessary to start it at all. In this case, you should disconnect the battery to prevent it from draining and potentially damaging the car's electrical system.",
	},
	{
		question: 'How do you store an RV battery when not in use?',
		answer:
			"Proper RV battery storage is crucial for maintaining battery life and ensuring your RV is ready for your next adventure. Here's the complete guide to storing your RV batteries safely:\n\n" +
			'1. **Remove the Battery Safely.** Disconnect your RV battery starting with the negative terminal, then the positive terminal. Clean the terminals with a wire brush and baking soda solution to remove any corrosion before storage.\n\n' +
			'2. **Choose the Right Storage Location.** Store your battery in a cool, dry indoor location like a basement, garage, or utility room. The ideal temperature range is between 32°F and 80°F. Never place the battery directly on concrete floors – use cardboard, wood, or a battery mat as insulation.\n\n' +
			'3. **Maintain Proper Charge Levels.** For traditional lead-acid batteries, store them at 100% charge to prevent sulfation and freezing damage. Lithium batteries should be stored at 50–80% charge for optimal longevity.\n\n' +
			'4. **Use a Battery Maintainer.** Connect a quality battery maintainer or tender to keep your battery at optimal charge levels throughout the storage period. These devices automatically monitor and maintain the proper voltage without overcharging.',
	},
	{
		question:
			'How do I find the right facility to store a motorhome or camper?',
		answer:
			'Your RV is a big investment, so choosing the right storage facility is important. Here are some things to consider when choosing the right RV storage facility:\n\n' +
			'- Location\n' +
			'- Security\n' +
			'- Covered or Uncovered\n' +
			'- Cost\n' +
			'- Amenities\n\n' +
			"Whether you're parking a compact pop-up or a luxury Class A motorhome, we'll help you find the right space at the right price.",
	},
	{
		question: 'Can you store a camper in a storage unit?',
		answer: "Yes, you absolutely can store a camper in a storage unit, and it's one of the most popular and secure storage options available. Professional camper storage offers security features like gated access and surveillance cameras, plus convenience with wide driveways and extended access hours.",
	},
];

export const RVContent = {
	type: 'RV',
	sections: [
		{
			title: 'RV Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'rv-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best RV Storage For You',
							description:
								'Finding a safe place to store an RV is more than just a solution to HOA-induced headaches and neighborhood gossip; it’s the best way to protect your recreational vehicle from extreme weather and space limitations. If you’re looking for safe, cheap RV storage, you’re in the right place. Browse thousands of storage options, compare RV storage rates instantly, and book online in minutes.',
							image: RVHero,
							CTAText: 'Find Storage Today',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular RV Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'RV-Storage Size Comparison',
			noPaddingBottom: true,
			modules: [
				{
					title: 'RV Storage Content',
					type: 'content',
					props: {
						title: 'RV Storage Space Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'RVs, campers, and travel trailers vary in size, so choosing the right RV storage space is important. Class A motorhome storage has different size requirements than vehicles that need Class B RV storage, such as compact campers. Learn the ins and outs of camper storage units and RV parking spaces with [SpareFoot’s handy size guide](https://www.sparefoot.com/storage-unit-size-guide.html).',
						],
					},
				},
				{
					title: 'Vehicle Storage Units',
					type: 'unitList',
					id: 'vehicle storage unit cards',
					props: {
						slug: 'vehicle-storage-unit-cards',
						scrollFactor: 3,
						unitsData: [
							{
								image: vehicle10x25,
								title: "10' x 25'",
								infoTag: '250 SQ FT',
								content:
									"25 foot RV storage spaces will work for smaller models of Class B campers, Class C campers, travel trailers, toy trailers and pop-ups. Some of these might even fit inside traditional 10' x 25' self-storage units, but make sure the height and width of the unit is sufficient for storing your RV before attempting to move in.",
							},
							{
								image: vehicle10x30,
								title: "10' x 30'",
								infoTag: '300 SQ FT',
								content:
									"This next category will handle smaller-to-medium sized Class B campers and travel trailers, large pop-ups, and smaller Class C campers and fifth-wheel trailers. Standard self-storage units go up to 10' x 30', but lack the necessary height to handle many of these vehicles (self-storage units typically only reach 8'-10' in height).",
							},
							{
								image: vehicle10x35,
								title: "10' x 35'",
								infoTag: '350 SQ FT',
								content:
									"35' RV storage spaces can typically contain large Class B and Class C campers, mid-to-large sized travel trailers, small-to-mid sized fifth-wheel campers, large toy trailers, and small Class A campers.",
							},
							{
								image: vehicle10x40,
								title: "10' x 40'",
								infoTag: '400 SQ FT',
								content:
									"All but the largest of RVs will fit into a 40' storage space. This includes most Class A campers, large travel trailers and fifth-wheel trailers. Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet.",
							},
							{
								image: vehicle10x50,
								title: "10' x 50'",
								infoTag: '500 SQ FT',
								content:
									"50' RV storage space will handle the largest of RVs. Class A campers, travel trailers and destination trailers will all fit within this space.",
							},
						],
					},
				},
			],
		},
		{
			title: 'video content',
			background: 'yellow',
			modules: [
				{
					title: 'RV Storage Content',
					type: 'content',
					ShowBackgroundImage: false,
					props: {
						title: 'Indoor RV Storage vs. Outdoor Camper Storage: What’s Best for You? ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: videoDescription,
					},
				},
				{
					type: 'videoSection',
					props: {
						slug: 'How to Pick the Right Storage Unit Size Video',
						src: 'https://www.youtube.com/embed/MtahSgCBlRg?si=wAnKPTszcg3bQOxY',
					},
				},
			],
		},
		{
			title: 'size guide table',
			modules: [
				{
					type: 'sizeChart',
					props: {
						slug: 'size-chart-section',
						columnWidths: [1, 1],
						title: 'How to Prepare Your RV for Storage',
						headers: [
							{
								label: 'Before You Store',
								key: 'Before You Store',
							},
							{
								label: 'Protect Your Investment',
								key: 'Protect Your Investment',
							},
						],
						rows: [
							{
								'Before You Store':
									'Disconnect the battery and all electrical devices',
								'Protect Your Investment':
									'Remove tires or use wheel chocks (prevents flat spots during long-term storage)',
							},
							{
								'Before You Store':
									'Empty and clean all water tanks at a dump station',
								'Protect Your Investment':
									'Inspect and seal roof vents; cover with mesh screens',
							},
							{
								'Before You Store':
									'Add antifreeze to pipes and drains - a key step to properly winterizing an RV',
								'Protect Your Investment':
									'Clean out all food and perishables; leave the fridge open to defrost',
							},
							{
								'Before You Store':
									'Top off propane tanks, then shut off the gas and remove the tanks if possible',
								'Protect Your Investment':
									'Cover your RV to protect it from weather, pests, and UV damage',
							},
							{
								'Before You Store':
									'Change fluids (oil, brake, radiator) and fill the gas tank with stabilizer',
								'Protect Your Investment': '',
							},
						],
					},
				},
			],
		},
		{
			title: 'tip content',
			background: 'yellow',
			modules: [
				{
					title: 'RV Storage tips Content',
					type: 'content',
					props: {
						title: 'Expert RV Storage Advice',
						contentType: 'row-type',
						contentImage: truckBoatCarContentSectionSVG,
						content: [
							'If storing over winter, remove the RV battery entirely and store it at room temperature. \n\n' +
								"[Following these steps keeps your RV road-ready](https://www.sparefoot.com/blog/how-to-winterize-rv) and prevents costly repairs when you're ready for your next adventure.",
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'SpareFoot Customers Experience Less RV Storage Stress',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'RV Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'How to Store it',
								date: 'October 20, 2025',
								image: RV1,
								link: 'https://sparefoot.com/blog/6-newbie-mistakes-to-avoid-when-storing-your-rv',
								content:
									'6 “Newbie” Mistakes to Avoid When Storing Your RV',
							},
							{
								title: 'General Storage Advice',
								date: 'September 9, 2024',
								image: RV2,
								link: 'https://sparefoot.com/blog/how-to-winterize-rv',
								content:
									'How to Winterize an RV: Steps For Protecting Your RV During Winter Storage',
							},
							{
								title: 'General Storage Advice',
								date: 'October 20, 2025',
								image: RV3,
								link: 'https://sparefoot.com/blog/how-much-does-rv-camper-storage-cost',
								content:
									'How Much Does it Cost to Store an RV?',
							},
							{
								title: 'How to Store It',
								date: 'October 20, 2025',
								image: RV4,
								link: 'https://sparefoot.com/blog/rv-storage-size-guide',
								content: 'RV Storage Size Guide',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'Boat',
							'Car',
							'DriveUp',
							'24Hour',
							'Electricity',
							'Portable',
							'ClimateControl',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
